<script setup>
import { cloneDeep } from 'lodash-es';
import BiTableWidget from '~/bi/components/widgets/table-widget/bi-table-widget.vue';
import { useBiStore } from '~/bi/store/bi.store';

const props = defineProps({
  unpivotData: {
    type: Object,
    required: true,
  },
  height: {
    type: Number,
    default: 300,
  },
});

const emit = defineEmits(['selection-end']);
const bi_store = useBiStore();
const store = useBiStore('unpivot');

const loading = ref(false);
async function fetchTableData() {
  try {
    loading.value = true;
    store.widget_builder_config = cloneDeep(bi_store.widget_builder_config);
    const index = store.widget_builder_config.query.stages.length - 1;
    store.widget_builder_config.query.stages[index].unpivot = props.unpivotData ? props.unpivotData : undefined;
    const widget_builder_data = await store.getWidgetData(store.widget_builder_config.query.stages);
    store.widget_builder_data = widget_builder_data.data;
    store.widget_builder_metadata = widget_builder_data.metadata;
  }
  catch (error) {
    console.error(error);
  }
  finally {
    loading.value = false;
  }
}
function additionalTableSettings() {
  return {
    bi_table_settings: {
      pagination: false,
      multiColumnSorting: false,
      outsideClickDeselects(event) {
        if (event.classList.contains('btn-content') || event.getAttribute('type') === 'button') {
          return false;
        }
        return true;
      },
    },
  };
}

fetchTableData();
</script>

<template>
  <div class="h-full w-full flex flex-col relative">
    <hawk-loader v-if="loading" />
    <div v-else class="flex-1 h-full overflow-hidden">
      <div v-if="store.query_config_error" class="flex items-center justify-center w-full h-full">
        <div class="flex flex-col items-center">
          <span class="inline-block bg-red-100 rounded-full p-3 text-red-500 -mt-4">
            <IconHawkAlertTriangle />
          </span>
          <div class="text-sm font-semibold mt-4">
            {{ $t('Invalid query') }}
          </div>
          <div class="text-sm text-gray-600  text-center">
            {{ store.query_config_error?.message }}
          </div>
          <div class="text-sm text-gray-600 w-[80%] mt-2 text-center">
            {{ store.query_config_error?.details }}
          </div>
        </div>
      </div>
      <BiTableWidget
        :is-builder="true"
        :config="{}"
        :height="height"
        :data="store.widget_builder_data"
        :widget-builder-metadata="store.widget_builder_metadata"
        :additional-config="additionalTableSettings()"
        @selection-end="emit('selection-end', $event)"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
:deep(.sql-area) {
  .ͼ5 .cm-activeLine,.ͼ5 .cm-activeLineGutter{
    background-color: transparent !important;
  }
  .ͼ5 .cm-gutters{
    display:none !important;
  }
  .cm-content{
    padding:0 !important;
  }
}
</style>
